import Dialog from 'components/ReusableComponents/Dialog'
import useEsc from 'hooks/useEsc'
import useKeyboard from 'hooks/useKeyboard'
import { useEffect } from 'react'
import { useRef, useState } from 'react'

import { ReactComponent as ChevronLeft } from './chevronLeft.svg'
import { ReactComponent as ChevronRight } from './chevronRight.svg'
import CloseIcon from './CloseIcon'
import styles from './ConversationBubble.module.scss'

const MediaGallery = ({ onClose, focusedMediaUrl, mediaList }) => {
  const ref = useRef()

  useEsc(onClose)

  const [focusedMedia, setFocusedMedia] = useState(focusedMediaUrl)

  const [mediaUrl, setMediaUrl] = useState()

  const activeMediaIndex = mediaList.findIndex(m => m.tempPublicPath === focusedMedia)

  const activeMedia = mediaList.find(m => m.tempPublicPath === focusedMedia)
  const width = activeMedia?.tags?.width
  const height = activeMedia?.tags?.height
  const type = activeMedia.tags.contentType.toLowerCase()

  useKeyboard(() => {
    if (activeMediaIndex < mediaList.length - 1) {
      handleClickNext()
    }
  }, 39)

  useKeyboard(() => {
    if (activeMediaIndex > 0) {
      handleClickPrev()
    }
  }, 37)

  useEffect(() => {
    setMediaUrl(activeMedia.tempPublicPath)
  }, [activeMedia])

  if (!focusedMedia) {
    return null
  }

  function handleClickNext() {
    setMediaUrl(null)
    setFocusedMedia(mediaList[activeMediaIndex + 1].tempPublicPath)
  }

  function handleClickPrev() {
    setMediaUrl(null)
    setFocusedMedia(mediaList[activeMediaIndex - 1].tempPublicPath)
  }

  return (
    <Dialog>
      {activeMediaIndex > 0 && (
        <button className={styles.mediaDialogPrevButton} onClick={handleClickPrev}>
          <ChevronLeft width={30} height={30} />
        </button>
      )}
      <div className={styles.gallery} ref={ref}>
        <button className={styles.galleryCloseButton} onClick={onClose}>
          <CloseIcon fill="white" width={28} height={28} />
        </button>
        {/* eslint-disable-next-line */}
        {type.includes('video') && (<video src={mediaUrl} autoPlay controls style={{ display: 'block' }} />)}
        {/* eslint-disable-next-line */}
        {type.includes('image') && <img src={mediaUrl} width={width} height={height} style={{ width: "100%", height: 'auto', objectFit: 'cover' }}/>}
      </div>
      {activeMediaIndex < mediaList.length - 1 && (
        <button className={styles.mediaDialogNextButton} onClick={handleClickNext}>
          <ChevronRight width={30} height={30} />
        </button>
      )}
    </Dialog>
  )
}

export default MediaGallery
